module.exports = __webpack_public_path__ + "img/huang.701c1220.png";